import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

const communityPages = [
  {
    text: 'Community-based Resources',
    href: '/toolkit/community/community-based-resources',
    description:
      'Explore resources and strategies for leveraging community-based organizations and assets in SCD care.'
  },
  {
    text: 'Limited SCD Providers',
    href: '/toolkit/community/limited-scd-providers',
    description:
      'Understand the challenges and solutions related to the limited availability of SCD providers in certain areas.'
  },
  {
    text: 'Collaborating with Political Leaders and Government Officials',
    href: '/toolkit/community/political-collaboration',
    description:
      'Learn how to effectively engage with policymakers to advocate for SCD resources and support.'
  },
  {
    text: 'Lack of Awareness of SCD or Stigma Towards SCD',
    href: '/toolkit/community/scd-awareness-stigma',
    description:
      'Address the issues of low awareness and stigma surrounding SCD through targeted community efforts.'
  }
  // {
  //   text: 'Effectiveness of Infusion Clinic',
  //   href: '/toolkit/community/effectiveness-of-infusion-clinic',
  //   description:
  //     'Review data and information on the impact of infusion clinics from a community perspective.',
  // },
  // {
  //   text: 'Community Based Organizations',
  //   href: '/toolkit/community/community-based-organizations-detail',
  //   description:
  //     'Find detailed information on specific community-based organizations involved in SCD care and advocacy.',
  // },
  // Note: The Community ECHO link, if it was listed here, would also be removed.
  // It's assumed to be accessed via 'Community-based Resources' now.
  // {
  //   text: 'Community Educational Materials',
  //   href: '/toolkit/community/community-educational-materials',
  //   description:
  //     'Access educational materials designed for community outreach and patient education on SCD.',
  // }
  // TODO: Add other community pages as they are created
]

export const CommunitySectionPage: React.FC = () => {
  return (
    <ToolkitPageLayout
      title="Community Resources"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Community', path: '/toolkit/community' }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416] mb-8">
        <p className="text-xl">
          This section focuses on the vital role of community engagement and
          resources in supporting individuals with Sickle Cell Disease (SCD).
          Discover tools for advocacy, awareness campaigns, and collaboration
          with local organizations to improve the lives of those affected by
          SCD.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {communityPages.map((page, index) => (
          <Link
            key={index}
            to={page.href}
            className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 transition-colors duration-200 transform hover:scale-105"
          >
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-[#142841]">
              {page.text}
            </h5>
            <p className="font-normal text-[#3C2416]">{page.description}</p>
          </Link>
        ))}
      </div>

      {/* "All Done" Button - links back to Toolkit Home */}
      <div className="mt-12 mb-8 text-center">
        <Link
          to="/toolkit"
          className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
        >
          All done? Click here to return to the Toolkit home
        </Link>
      </div>
    </ToolkitPageLayout>
  )
}
